<template>
  <v-dialog v-model="dialogmodel" width="500" persistent>
    <v-card>
      <v-card-text class="pa-4 pre-line grey--text text--darken-4 text-subtitle-1 px-5">
        <p class="mb-4">
          {{ this.dialogData.message }}
        </p>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn text @click="cancel"> {{ $t('common.action.cancel') }} </v-btn>
        <v-btn color="indigo darken-1" dark @click="ok">
          {{ $t('common.action.ok') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// 汎用的な確認ダイアログ
// dialogData.message 確認メッセージ
export default {
  props: {
    handleOk: {
      type: Function,
      required: true,
    },
    handleCancel: {
      type: Function,
      required: true,
    },
    dialogData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialogmodel: true,
      loading: false
    };
  },
  methods: {
    ok() {
      this.handleOk();
    },
    cancel() {
      this.handleCancel();
    },
  },
};
</script>
<style>
.pre-line {
  white-space: pre-line;
}
</style>
